import React, { useState, Suspense, lazy, useEffect} from 'react'
import Header from '../components/header.jsx';
import Welcome from '../components/welcome.jsx';
import './home.css';
// import { data } from 'react-router-dom';


const Time = lazy(() => import('../components/time.jsx'));
const Story = lazy(() => import('../components/story.jsx'));
const Location = lazy(() => import('../components/location.jsx'));
const Thank = lazy(() => import('../components/thank.jsx'));
const DressCode = lazy(() => import('../components/dresscode.jsx'));

const PETAL_EMOJIS = ['💍','💒','👰','🤵','💕','🥂','🕊️','💐','🌹','✨','🌸','🌷','💮','🫧','🤍','💫'];

const petals = Array.from({ length: 35}, (_, i) => ({
  id: i,
  left:  `${Math.random() * 105 - 2}%`,
  size:  10 + Math.random() * 14,
  emoji: PETAL_EMOJIS[Math.floor(Math.random() * PETAL_EMOJIS.length)],
  dur:   `${5 + Math.random() * 7}s`,
  delay: `${Math.random() * 6}s`,
  sway:  `${(Math.random() - 0.5) * 120}px`,
  op:    0.3 + Math.random() * 0.45,
}));

export default function Home() {
  const [showLanding, setShowLanding] = useState(true);
  const [opening, setOpening] = useState(false);
  const [status, setStatus] = useState(false);
  const handleOpen = () => {
    if (opening) return;
    setOpening(true);
    setTimeout(() => {
        setShowLanding(false);
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, 1600);
  };
  useEffect(() => {
    let cancelled = false;
    const fetchStatus = async () => {
        const BASE_DELAY = 3000;
        const MAX_RETRIES = 20;
        for(let attempt = 0; attempt < MAX_RETRIES; attempt++){
          if(cancelled) return;
          try{
          const data = await fetch('https://duyphuongwedding.onrender.com/awake');
            if(!data.ok){
              throw new Error("Cannot wake up backend");
            }
            if(!cancelled) setStatus(true);
            return;
          }
          catch(err){
            const delay = Math.min(BASE_DELAY * 2 ** attempt, 15000);
            await new Promise(resolve => setTimeout(resolve, delay));
          }
        }
    };
    fetchStatus();
    return () => {cancelled = true;};
  }, []);

  return (
    <div>

      {/* ── ENVELOPE OVERLAY ── */}
      {showLanding && (
        <div className={`landing-overlay ${opening ? 'fade-out' : ''}`}>
          {/* ── FALLING PETALS inside overlay ── */}
          <div className="petals">
            <style>{petals.map(p => `
              .petal-${p.id} {
                left: ${p.left};
                font-size: ${p.size}px;
                animation-duration: ${p.dur};
                animation-delay: ${p.delay};
                --sway: ${p.sway};
                --op: ${p.op};
              }
            `).join('')}</style>
            {petals.map(p => (
              <div key={p.id} className={`petal petal-${p.id}`}>
                {p.emoji}
              </div>
            ))}
          </div>

          <div className={`envelope-scene ${opening ? 'opened' : ''}`} onClick={handleOpen}>
            <div className="env-body">
              <div className="env-left" />
              <div className="env-right" />
              <div className="env-base" />
              <div className="inner-card">
                <div className="card-top-border" />
                <p className="card-label">We Are Married</p>
                <p className="card-names">Duy <span className="card-amp">&</span> Phuong</p>
                <div className="card-divider">✦</div>
                <p className="card-date">May · 31 · 2026</p>
              </div>
            </div>
            <div className="env-flap">
              <div className="env-flap-face" />
            </div>
            <div className="wax-seal">
              <div className="seal-circle">
                <div className="seal-pulse" />
                <span className="seal-text">D&P</span>
              </div>
            </div>
          </div>

          <p className="hint">tap to reveal our news</p>
        </div>
      )}

      {/* ── HOME PAGE CONTENT ── */}
      <div className={showLanding ? 'page-hidden' : 'page-visible'}>
        <div className='home'>
          <Header autoPlay={!showLanding} />
          <Welcome />
          <Suspense fallback={null}>
            <Time />
            <Story />
            <Location/>
            <DressCode/>
            <Thank />
          </Suspense>
        </div>
      </div>

    </div>
  );
}